import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
    responseType: 'arraybuffer'
})

service.interceptors.request.use(config => {
    config.headers['userIdStr'] = window.sessionStorage.getItem('userIdStr');
    return config;
}, error => {
    console.log(error);
})


service.interceptors.response.use(resp => {
    const headers = resp.headers;
    let reg = RegExp(/application\/json/);
    if (headers['content-type'].match(reg)) {
        resp.data = unitToString(resp.data);
    } else {
        let fileDownload = require('js-file-download');
        let fileName = headers['content-disposition'].split(';')[1].split('filename=')[1];
        let contentType = headers['content-type'];
        fileName = decodeURIComponent(fileName);
        fileDownload(resp.data, fileName, contentType);
    }
}, error => {
    console.log(error);
})


function unitToString(unitArray) {
    let encodedString = String.fromCharCode.apply(null, new Uint8Array(unitArray));
    let decodedString = decodeURIComponent(escape(encodedString));
    return JSON.parse(decodedString);
}


let base = 'work';
export const downloadRequest = (url, params) => {
    return service({
        method: 'get',
        url: `${base}${url}`,
        data: params
    })
}


export default service;


/**
 * 保存后端返回的文件流为本地文件（配合 request3 的 responseType: 'blob'）。
 *
 * 后端导出异常时会以 200 + JSON 体（Content-Type: application/json）返回错误提示，
 * 此处先识别并解析该情形，避免用户下载到损坏文件。
 *
 * @param {Blob} blob 文件流
 * @param {String} fileName 保存的文件名
 * @returns {Promise<Boolean>} true=已触发保存；false=解析出后端错误并已提示
 */
export function saveBlobAs(blob, fileName) {
    if (!blob || !(blob instanceof Blob)) {
        Message.error((blob && blob.msg) || '导出失败，请稍后重试')
        return Promise.resolve(false)
    }
    if (blob.type && blob.type.indexOf('json') > -1) {
        return blob.text().then(text => {
            let msg = '导出失败，请稍后重试'
            try {
                msg = JSON.parse(text).msg || msg
            } catch (e) {
                // 非标准 JSON 时保留默认提示
            }
            Message.error(msg)
            return false
        })
    }
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName || 'download'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
    return Promise.resolve(true)
}


/**
 * 生成带时间戳的文件名（yyyyMMddHHmmss）。
 *
 * @param {String} prefix 文件名前缀（不含扩展名）
 * @param {String} ext 扩展名（默认 xlsx）
 */
export function timestampFileName(prefix, ext) {
    const now = new Date()
    const pad = n => (n < 10 ? '0' + n : String(n))
    const stamp = String(now.getFullYear()) + pad(now.getMonth() + 1) + pad(now.getDate()) +
        pad(now.getHours()) + pad(now.getMinutes()) + pad(now.getSeconds())
    return (prefix || 'download') + '_' + stamp + '.' + (ext || 'xlsx')
}
